export const safeNavigator = typeof navigator !== "undefined" ? navigator : undefined;
//# sourceMappingURL=safeNavigator.js.map